import { callApi } from '@local_modules/generic/fetch'

export async function loadSyncDetails (dataSyncId) {
  const apiUrl = '/api/data-sync/details/:dataSyncId'
  const data = await callApi(apiUrl, {
    dataSyncId
  })
  // console.log('api data', data)

  return data
}
